import React, {useState} from 'react';
import ModalFormSubmit from "../../../../../share-components/form/modalFormSubmit";
import ProductCategoryForm from "../../../../manage-product/product-setting/product-category/productCategoryForm";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {closeEditDialog} from "../../../../manage-product/store/productCategorySlice";
import {useDispatch, useSelector} from "react-redux";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {setOrderDiscountDialog} from "../../../store/draftOrderSlice";

const defaultValues = {
    discount_type: 1,
    value: '',
    reason: '',
};
const schema = yup.object().shape({
    discount_type: yup.string().required('You must select typ'),
    value: yup.string().required('You must enter value'),

});


function OrderDiscount(props) {
    const dispatch = useDispatch();
    const {orderSetValue,orderTrigger,orderGetValues}=props;
    const [buttonDisable, setButtonDisable] = useState(false);
    const {handleSubmit, formState, reset, control, register, setValue, handleChange, trigger, getValues} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const {errors} = formState;
    const onSubmitForm = (dialog, data) => {
        setButtonDisable(true);
        orderSetValue('discount',data);
        orderTrigger('discount');
        setButtonDisable(false);
        closeDialog();

    }
    const closeDialog = () => {
        const obj = {props: {isOpen: false},type:'new',data:""};
        dispatch(setOrderDiscountDialog(obj));

    }
    const orderState = useSelector(({order}) => order.draftOrder);


    return (
        <ModalFormSubmit
            defaultValues={defaultValues}
            schema={schema}
            onSubmitForm={onSubmitForm}
            reset={reset}
            formState={formState}
            handleSubmit={handleSubmit}
            title='Discount'
            selector='discount'
            isUseSelector
            dialog={orderState.discountDialogProps}
            closeDialog={closeDialog}
            buttonDisable={buttonDisable}
        >

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label className="col-form-label">Discount Type</Label>
                        <Input type="select" name="select" onChange={(e)=>{
                            setValue('discount_type',e.target.value);
                        }}   className={`form-control ${errors.discount_type ? 'is-invalid' : ''}`} defaultValue={getValues('discount_type')} >
                            <option value="1">Amount</option>
                            <option value="2">Percentage</option>
                        </Input>
                        <div className="invalid-feedback">{errors.discount_type?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label className="col-form-label">Value</Label>
                        <input name="value" type="text" {...register('value')}
                               className={`form-control ${errors.value ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.value?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="col-form-label">Reason</Label>
                        <input name="reason" type="text" {...register('reason')}
                               className={`form-control`}/>

                    </FormGroup>
                </Col>
            </Row>
            {orderGetValues('discount')&&<Row>
                <Col md={12}>
                    <button className="btn btn-danger btn-sm float-right" onClick={()=>{
                        orderSetValue('discount',"");
                        orderTrigger('discount');
                        closeDialog();
                    }
                    }>Remove <i className="fa fa-trash"></i></button>
                </Col>
            </Row>}

        </ModalFormSubmit>
    );
}

export default OrderDiscount;